function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { ChevronDownIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { ChevronLeftIcon, ChevronRightIcon, ChevronUpDownIcon, FunnelIcon, MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { flexRender, getCoreRowModel, useReactTable } from "@tanstack/react-table";
import cc from "classcat";
import usePagination from "headless-pagination-react";
import debounce from "lodash.debounce";
import PropTypes from "prop-types";
import { parse } from "qs";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Outlet, useLoaderData, useNavigation, useOutletContext, useRevalidator } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { useDispatch, useSelector } from "react-redux";
import useNavigate from "../../vendor/router/useNavigate";
import CentralLoader from "../uikit/CentralLoader";
import Input from "../uikit/Input/Input";
import PrivatePageHeader from "./Page/PrivatePageHeader";
import PrivatePageTitle from "./Page/PrivatePageTitle";
import { listFactoryActions, listFactorySelectors } from "../../redux/listFactory";
import Checkbox from "../uikit/Checkbox";
import { screenBreakpointsSelectors } from "../../redux/screenBreakpoints";
import ReactSelect from "../uikit/Select/ReactSelect";
import handleReportError from "../errors/handleReportError";
import { useModalManagerContext } from "./ModalManagerContext";
import Trans from "../intl/Trans";
export var SORT_ASC = "asc";
export var SORT_DESC = "desc";
var DELAY_FOR_SYNC_URL = 500; // miliseconds
export var CUSTOM_FILTER_COMPONENT = "customFilterComponent";
export var CUSTOM_AUTOCOMPLETE_FILTER_COMPONENT = "customAutocompleteFilterComponent";
export var CUSTOM_ASYNC_MULTI_SELECT_FILTER_COMPONENT = "customAsyncMultiSelectFilterComponent";
export function createFiltersValueMapObject(value, operators) {
    var splitBy = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : ",";
    var values = value.split(splitBy);
    var filterObject = {};
    operators.forEach(function(operator, index) {
        filterObject[operator] = values[index];
    });
    return filterObject;
}
export default function makeListFactory(param) {
    var defaultSortByField = param.defaultSortByField, _param_defaultPerPage = param.defaultPerPage, defaultPerPage = _param_defaultPerPage === void 0 ? 10 : _param_defaultPerPage, listingApi = param.listingApi, initialDataLoadingApi = param.initialDataLoadingApi, _param_filtersMap = param.filtersMap, filtersMap = _param_filtersMap === void 0 ? {} : _param_filtersMap, _param_filtersFieldsMap = param.filtersFieldsMap, filtersFieldsMap = _param_filtersFieldsMap === void 0 ? {} : _param_filtersFieldsMap, _param_filtersModalSize = param.filtersModalSize, filtersModalSize = _param_filtersModalSize === void 0 ? "xs" : _param_filtersModalSize, loaderId = param.loaderId, _param_defaultSortDirection = param.defaultSortDirection, defaultSortDirection = _param_defaultSortDirection === void 0 ? SORT_ASC : _param_defaultSortDirection, _param_isOutletRenderedByParent = param.isOutletRenderedByParent, isOutletRenderedByParent = _param_isOutletRenderedByParent === void 0 ? false : _param_isOutletRenderedByParent, _param_filtersToIgnore = param.filtersToIgnore, filtersToIgnore = _param_filtersToIgnore === void 0 ? [] : _param_filtersToIgnore;
    var debouncedApi = debounce(function(a, b, resolve, reject) {
        return listingApi(a, b).then(resolve).catch(reject);
    }, DELAY_FOR_SYNC_URL);
    function generateApiFilters(filters) {
        return Object.keys(filters).map(function(filter) {
            //* If current filter is in filtersFromValueMap keys, we call the function for this filter which might return
            //* multiple pairs of operator,value to be used to generate new filters
            if (Object.keys(filtersMap).includes(filter)) {
                var filterFunction = filtersMap[filter];
                if (typeof filterFunction === "function") {
                    var filtersFromValueMap = Object.entries(filterFunction(filters[filter])).map(function(param) {
                        var _param = _sliced_to_array(param, 2), operator = _param[0], value = _param[1];
                        return {
                            field: filter,
                            operator: operator,
                            value: value
                        };
                    });
                    return filtersFromValueMap;
                }
            }
            return {
                field: filtersFieldsMap && filtersFieldsMap[filter] ? filtersFieldsMap[filter] : filter,
                operator: filtersMap[filter],
                value: filters[filter]
            };
        }).flat(1) //* Since when we have a match in filtersFromValueMap it might return multiple filters for a field
        //We don't send the filter if its value is "" after trim
        .filter(function(filterItem) {
            var _filterItem_value;
            return _type_of(filterItem.value) !== "object" ? !filtersToIgnore.includes(filterItem.field) && ((_filterItem_value = filterItem.value) === null || _filterItem_value === void 0 ? void 0 : _filterItem_value.toString().trim()) !== "" : !filtersToIgnore.includes(filterItem.field);
        });
    }
    function dataLoader(_, _1) {
        return _dataLoader.apply(this, arguments);
    }
    function _dataLoader() {
        _dataLoader = _async_to_generator(function(param, param1) {
            var request, params, dispatch, getState, _parse, _parse_page, page, _parse_sortBy, sortBy, _parse_sortDir, sortDir, _parse_search, search, _parse_filters, filters, processedFilters, prev, shouldDisableDebounce, currentListingLoader, initialLoadedData, result, loadedData;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        request = param.request, params = param.params, dispatch = param1.dispatch, getState = param1.getState;
                        _parse = parse(new URL(request.url).search.substring(1)), _parse_page = _parse.page, page = _parse_page === void 0 ? "1" : _parse_page, _parse_sortBy = _parse.sortBy, sortBy = _parse_sortBy === void 0 ? defaultSortByField : _parse_sortBy, _parse_sortDir = _parse.sortDir, sortDir = _parse_sortDir === void 0 ? defaultSortDirection : _parse_sortDir, _parse_search = _parse.search, search = _parse_search === void 0 ? "" : _parse_search, _parse_filters = _parse.filters, filters = _parse_filters === void 0 ? {} : _parse_filters;
                        processedFilters = generateApiFilters(filters);
                        prev = listFactorySelectors.getCurrentListingState(getState());
                        //When the page / sortDir / sortBy from url is different than the previous values it means the user has changed
                        // the sorting or has clicked a new page and we shouldn't debounce the loadData
                        // When the filters change we we shouldn't debounce the loadData
                        shouldDisableDebounce = prev && (prev.page !== page || prev.sortDir !== sortDir || prev.sortBy !== sortBy || Object.keys(filters).length > 0 && search === prev.search);
                        //If we had filters and the user has clicked reset the only difference in state is that we won't have any search
                        // or filters but we'll have the old page/sortDir/sortBy so we shouldn't debounce the loadData
                        if (prev && !shouldDisableDebounce && prev.page === page && prev.sortDir === sortDir && prev.sortBy === sortBy && !search && Object.keys(filters).length === 0) {
                            shouldDisableDebounce = true;
                        }
                        // We don't want the debounce when we change filters, but since we can filter the results that we get from search
                        // we need to save the search value too, otherwise when we change a filter, it will be debounced if search is
                        // not empty
                        dispatch(listFactoryActions.setCurrentListingState({
                            page: page,
                            sortDir: sortDir,
                            sortBy: sortBy,
                            search: search
                        }));
                        /**
         * The delay from debounce (500ms) will apply whenever we navigate to listings and it will make the app slower,
         *  so we use debouncedApi only when we change filters/search, by comparing the loaderId which is given by
         *  each Listing component with the value from redux.
         *  Otherwise, we use listingApi directly and change the currentListingLoader value.
         */ currentListingLoader = listFactorySelectors.getCurrentListingLoader(getState());
                        initialLoadedData = listFactorySelectors.getInitialLoadedData(getState());
                        return [
                            4,
                            new Promise(function(resolve, reject) {
                                if (currentListingLoader !== loaderId) {
                                    if (initialDataLoadingApi) {
                                        Promise.all([
                                            listingApi({
                                                dispatch: dispatch,
                                                getState: getState,
                                                abortControllerSignal: request.signal,
                                                params: params
                                            }, {
                                                page: page,
                                                perPage: defaultPerPage,
                                                sortBy: sortBy,
                                                sortDir: sortDir,
                                                search: search,
                                                filters: processedFilters
                                            }),
                                            initialDataLoadingApi({
                                                dispatch: dispatch,
                                                getState: getState,
                                                abortControllerSignal: request.signal,
                                                params: params
                                            })
                                        ]).then(resolve).catch(reject);
                                    } else {
                                        Promise.all([
                                            listingApi({
                                                dispatch: dispatch,
                                                getState: getState,
                                                abortControllerSignal: request.signal,
                                                params: params
                                            }, {
                                                page: page,
                                                perPage: defaultPerPage,
                                                sortBy: sortBy,
                                                sortDir: sortDir,
                                                search: search,
                                                filters: processedFilters
                                            })
                                        ]).then(resolve).catch(reject);
                                    }
                                    dispatch(listFactoryActions.setCurrentListingLoader(loaderId));
                                } else {
                                    if (initialDataLoadingApi && initialLoadedData === null) {
                                        Promise.all([
                                            listingApi({
                                                dispatch: dispatch,
                                                getState: getState,
                                                abortControllerSignal: request.signal,
                                                params: params
                                            }, {
                                                page: page,
                                                perPage: defaultPerPage,
                                                sortBy: sortBy,
                                                sortDir: sortDir,
                                                search: search,
                                                filters: processedFilters
                                            }),
                                            initialDataLoadingApi({
                                                dispatch: dispatch,
                                                getState: getState,
                                                abortControllerSignal: request.signal,
                                                params: params
                                            })
                                        ]).then(resolve).catch(reject);
                                        dispatch(listFactoryActions.setCurrentListingLoader(loaderId));
                                    } else {
                                        if (shouldDisableDebounce) {
                                            Promise.all([
                                                listingApi({
                                                    dispatch: dispatch,
                                                    getState: getState,
                                                    abortControllerSignal: request.signal,
                                                    params: params
                                                }, {
                                                    page: page,
                                                    perPage: defaultPerPage,
                                                    sortBy: sortBy,
                                                    sortDir: sortDir,
                                                    search: search,
                                                    filters: processedFilters
                                                })
                                            ]).then(resolve).catch(reject);
                                        }
                                        if (!shouldDisableDebounce) {
                                            debouncedApi({
                                                dispatch: dispatch,
                                                getState: getState,
                                                abortControllerSignal: request.signal,
                                                params: params
                                            }, {
                                                page: page,
                                                perPage: defaultPerPage,
                                                sortBy: sortBy,
                                                sortDir: sortDir,
                                                search: search,
                                                filters: processedFilters
                                            }, function(result) {
                                                return resolve([
                                                    result
                                                ]);
                                            }, reject);
                                        }
                                    }
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (initialDataLoadingApi && result && result[1]) {
                            dispatch(listFactoryActions.setInitialLoadedData(result[1]));
                        }
                        loadedData = result[0];
                        return [
                            2,
                            {
                                loaderData: _object_spread_props(_object_spread({}, loadedData), {
                                    /**
                 *   ⚠️ Warning: If the user switches tabs very quickly, there's a chance that `initialLoadedData`
                 *     could briefly reference stale data. This happens because the data fetching might not
                 *     complete before the new tab's content starts rendering. As a result, the destructured value
                 *     from `initialLoadedData` could be `undefined` for a brief moment, because we fall back to the previous
                 *     `initialLoadedData` if the new data (`result[1]`) is unavailable and the fallback data might be from a
                 *     different tab, potentially causing inconsistencies.
                 */ initialLoadedData: result && result[1] || initialLoadedData
                                }),
                                page: parseInt(page),
                                sortBy: sortBy,
                                sortDir: sortDir,
                                search: search,
                                filters: filters
                            }
                        ];
                }
            });
        });
        return _dataLoader.apply(this, arguments);
    }
    DataList.propTypes = {
        columns: PropTypes.arrayOf(PropTypes.shape({
            header: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.node
            ]).isRequired,
            accessorKey: PropTypes.string,
            cell: PropTypes.func.isRequired,
            enableSorting: PropTypes.bool.isRequired,
            tdClassName: PropTypes.string.isRequired,
            thClassName: PropTypes.string.isRequired
        })),
        filtersConfig: PropTypes.arrayOf(PropTypes.shape({
            field: PropTypes.string,
            operator: PropTypes.oneOfType([
                PropTypes.string,
                PropTypes.func
            ]),
            label: PropTypes.string,
            type: PropTypes.string,
            tooltip: PropTypes.oneOfType([
                PropTypes.node,
                PropTypes.string
            ]),
            className: PropTypes.string,
            options: PropTypes.array
        })),
        currentRoute: PropTypes.string.isRequired,
        title: PropTypes.string,
        createButton: PropTypes.node,
        emptyState: PropTypes.node,
        filtersEmptyState: PropTypes.func,
        searchClassName: PropTypes.string,
        listActions: PropTypes.func,
        selectedItemsLabel: PropTypes.func,
        primaryKey: PropTypes.string,
        showTableFromBreakpoint: PropTypes.string,
        isLoading: PropTypes.bool,
        handleRowClick: PropTypes.func
    };
    function DataList(param) {
        var columns = param.columns, filtersConfig = param.filtersConfig, currentRoute = param.currentRoute, title = param.title, createButton = param.createButton, emptyState = param.emptyState, filtersEmptyState = param.filtersEmptyState, _param_searchClassName = param.searchClassName, searchClassName = _param_searchClassName === void 0 ? "" : _param_searchClassName, listActions = param.listActions, selectedItemsLabel = param.selectedItemsLabel, _param_primaryKey = param.primaryKey, primaryKey = _param_primaryKey === void 0 ? "id" : _param_primaryKey, _param_showTableFromBreakpoint = param.showTableFromBreakpoint, showTableFromBreakpoint = _param_showTableFromBreakpoint === void 0 ? "xl" : _param_showTableFromBreakpoint, isLoading = param.isLoading, handleRowClick = param.handleRowClick;
        var _navigation_location;
        /**
         * --------------------
         * Translation for the current page
         * --------------------
         */ var _useTranslation = useTranslation(), translate = _useTranslation.t;
        /**
         * The navigate is used for the sync url
         */ var navigate = useNavigate();
        var dispatch = useDispatch();
        /**
         * --------------------
         * Get the initial data when the page is loaded
         * --------------------
         */ var _useLoaderData = useLoaderData(), loaderData = _useLoaderData.loaderData, currentPage = _useLoaderData.page, currentSortBy = _useLoaderData.sortBy, currentSortDir = _useLoaderData.sortDir, currentSearch = _useLoaderData.search, currentFilters = _useLoaderData.filters;
        /**
         * Table - Columns & Data
         */ var tableData = useMemo(function() {
            return loaderData.items;
        }, [
            loaderData.items
        ]);
        /**
         * Table
         */ var table = useReactTable({
            data: tableData,
            columns: columns,
            state: {
                id: currentSortBy,
                desc: currentSortDir === SORT_DESC
            },
            getCoreRowModel: getCoreRowModel(),
            debugTable: false,
            enableSortingRemoval: false
        });
        /**
         * Table - Sorting
         */ function mobileChangeSorting(param) {
            var _param_column = param.column, column = _param_column === void 0 ? currentSortBy : _param_column, _param_direction = param.direction, direction = _param_direction === void 0 ? currentSortDir : _param_direction;
            syncUrl({
                sortBy: column,
                sortDir: direction
            });
        }
        function changeSorting(columnId) {
            syncUrl({
                sortBy: columnId,
                sortDir: columnId === currentSortBy ? currentSortDir === SORT_DESC ? SORT_ASC : SORT_DESC : SORT_ASC
            });
        }
        /**
         * Search
         */ var _useState = _sliced_to_array(useState(currentSearch), 2), searchValue = _useState[0], setSearchValue = _useState[1];
        // Internal search function here, keep the input in sync with the local component state
        // plus with the URL but delayed/debounced.
        function onSearch(e) {
            setSearchValue(e.target.value);
            if (e.target.value.trim() === (currentSearch === null || currentSearch === void 0 ? void 0 : currentSearch.trim())) {
                return;
            }
            // Reset checked rows on search
            if (checkedRowsIds.length > 0) {
                setCheckedRowsIds([]);
            }
            if (pagesWithAllRowsChecked.length > 0) {
                setPagesWithAllRowsChecked([]);
            }
            if (checkedAllPages) {
                setCheckedAllPages(false);
            }
            if (excludedIds.length > 0) {
                setExcludedIds([]);
            }
            syncUrl({
                search: e.target.value.trim(),
                page: "1"
            });
        }
        /**
         * Table - Loader
         */ var navigation = useNavigation();
        var _useRevalidator = useRevalidator(), revalidatorState = _useRevalidator.state;
        var isReloadingTable = isLoading || revalidatorState === "loading" || navigation.state === "loading" && ((_navigation_location = navigation.location) === null || _navigation_location === void 0 ? void 0 : _navigation_location.pathname) === currentRoute;
        /**
         * Filters
         */ var _useState1 = _sliced_to_array(useState(currentFilters), 2), filters = _useState1[0], setFilters = _useState1[1];
        var _useState2 = _sliced_to_array(useState(false), 2), isFiltersModalLoading = _useState2[0], setIsFiltersModalLoading = _useState2[1];
        function onMobileApplyFilters(mobileFilters) {
            setFilters(mobileFilters);
            // Reset checked rows on filter
            if (checkedRowsIds.length > 0) {
                setCheckedRowsIds([]);
            }
            if (pagesWithAllRowsChecked.length > 0) {
                setPagesWithAllRowsChecked([]);
            }
            if (checkedAllPages) {
                setCheckedAllPages(false);
            }
            if (excludedIds.length > 0) {
                setExcludedIds([]);
            }
            syncUrl({
                filters: mobileFilters,
                page: "1"
            });
        }
        function onResetFilters() {
            var currentMobileFilters = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
            if (currentMobileFilters && Object.keys(currentMobileFilters).length === 0 && searchValue === "") {
                return;
            }
            if (!currentMobileFilters && Object.keys(filters).length === 0 && searchValue === "") {
                return;
            }
            // Reset checked rows on reset filters
            if (checkedRowsIds.length > 0) {
                setCheckedRowsIds([]);
            }
            if (pagesWithAllRowsChecked.length > 0) {
                setPagesWithAllRowsChecked([]);
            }
            if (checkedAllPages) {
                setCheckedAllPages(false);
            }
            if (excludedIds.length > 0) {
                setExcludedIds([]);
            }
            setFilters({});
            setSearchValue("");
            //we use this to not debounce even if filters/search were changed by the reset
            syncUrl({
                filters: {},
                search: "",
                page: "1"
            });
        }
        var showModalAsync = useModalManagerContext().showModalAsync;
        function onOpenMobileFiltersModal() {
            //! Don't change this to showModal, needs to be showModalAsync
            setIsFiltersModalLoading(true);
            showModalAsync({
                componentLoader: function() {
                    return import("./FiltersModal");
                },
                handleLoadError: function(error) {
                    handleReportError(error);
                    setIsFiltersModalLoading(false);
                },
                onClose: function() {
                    return setIsFiltersModalLoading(false);
                },
                initialProps: {
                    filtersModalSize: filtersModalSize,
                    onMobileApplyFilters: onMobileApplyFilters,
                    filtersConfig: filtersConfig,
                    onResetFilters: onResetFilters,
                    currentRoute: currentRoute,
                    currentFilters: currentFilters
                },
                onAbortLoading: function() {
                    return setIsFiltersModalLoading(false);
                }
            });
        }
        /**
         * SYNC INPUTS FROM URL ON BACK/FORWARD
         */ useEffect(function() {
            if (searchValue === currentSearch) {
                return;
            }
            setSearchValue(currentSearch);
        }, [
            currentSearch
        ]);
        useEffect(function() {
            if (JSON.stringify(filters) === JSON.stringify(currentFilters)) {
                return;
            }
            setFilters(currentFilters);
        }, [
            JSON.stringify(currentFilters)
        ]);
        /**
         * Pagination
         */ var _usePagination = usePagination({
            /**
             * If we are on page 2+ and we filter for something that gives 0 results the loaderData.count will be 0
             * and react pagination page will be 0 even if we run the setPage with 1. Thus when we clear the filters
             * and we are on page 1 the react pagination will not be synced with the url page because the url page
             * has not changed and the pagination links will not be highlighted
             */ totalItems: loaderData.count === 0 ? 1 : loaderData.count,
            perPage: defaultPerPage,
            maxLinks: 7,
            initialPage: currentPage
        }), links = _usePagination.links, hasNext = _usePagination.hasNext, hasPrevious = _usePagination.hasPrevious, reactPaginationPage = _usePagination.page, reactPaginationSetPage = _usePagination.setPage, totalPages = _usePagination.totalPages;
        // Sync react pagination page with URL
        useEffect(function() {
            if (currentPage === reactPaginationPage) {
                return;
            }
            reactPaginationSetPage(currentPage);
        }, [
            currentPage
        ]);
        /**
         * If we are on the last page and we have only 1 item, if we delete it, the url won't be synced
         * and we will be on a page with no items, so we sync the url with the last page, but because of revalidate,
         * we will see the "no items" screen before the url sync
         *
         */ useEffect(function() {
            if (currentPage <= totalPages) {
                return;
            }
            syncUrl({
                page: totalPages
            });
        }, [
            totalPages
        ]);
        function onNextPage() {
            if (!hasNext) {
                return;
            }
            syncUrl({
                page: currentPage + 1
            });
        }
        function onPreviousPage() {
            if (!hasPrevious) {
                return;
            }
            syncUrl({
                page: currentPage - 1
            });
        }
        /**
         * Move all local state into the url
         */ function syncUrl(param) {
            var _param_sortBy = param.sortBy, sortBy = _param_sortBy === void 0 ? sortBy || currentSortBy : _param_sortBy, _param_sortDir = param.sortDir, sortDir = _param_sortDir === void 0 ? sortDir || currentSortDir : _param_sortDir, _param_page = param.page, page = _param_page === void 0 ? currentPage : _param_page, _param_search = param.search, search = _param_search === void 0 ? currentSearch : _param_search, _param_filters = param.filters, filters = _param_filters === void 0 ? currentFilters : _param_filters;
            var query = {
                sortBy: sortBy,
                sortDir: sortDir
            };
            if (page > 1) {
                query.page = page;
            }
            if (search) {
                query.search = search;
            }
            if (filters) {
                query.filters = filters;
            }
            navigate(currentRoute, null, query);
        }
        var outletCtx = useOutletContext();
        useEffect(function() {
            /**
             * When the Listing component is unmounted, we want to reset the currentListingLoader
             */ return function() {
                // we don't want to clear prev here, so we call these 2 instead of resetCurrentListingState
                dispatch(listFactoryActions.setCurrentListingLoader(null));
                dispatch(listFactoryActions.setCurrentListingState(null));
            };
        }, []);
        /**
         * Checkbox state
         */ var _useState3 = _sliced_to_array(useState([]), 2), checkedRowsIds = _useState3[0], setCheckedRowsIds = _useState3[1];
        var _useState4 = _sliced_to_array(useState([]), 2), excludedIds = _useState4[0], setExcludedIds = _useState4[1];
        var _useState5 = _sliced_to_array(useState([]), 2), pagesWithAllRowsChecked = _useState5[0], setPagesWithAllRowsChecked = _useState5[1];
        var _useState6 = _sliced_to_array(useState(false), 2), checkedAllPages = _useState6[0], setCheckedAllPages = _useState6[1];
        /**
         * Checkbox handler
         */ function onCheckOneRow(rowId) {
            var isChecked = checkedRowsIds.indexOf(rowId);
            if (isChecked === -1) {
                var newCheckedRowsIds = _to_consumable_array(checkedRowsIds);
                // If all pages were checked, remove the row from excluded rows list in case it was excluded before
                if (checkedAllPages) {
                    var newExcludedRowsIds = excludedIds.filter(function(item) {
                        return item !== rowId;
                    });
                    setExcludedIds(newExcludedRowsIds);
                }
                newCheckedRowsIds.push(rowId);
                // If we checked all the rows from the list, add the page to the array of pages with all rows checked
                if (!loaderData.items.find(function(item) {
                    return !newCheckedRowsIds.includes(item.id);
                }) && !pagesWithAllRowsChecked.includes(currentPage)) {
                    setPagesWithAllRowsChecked(function(prev) {
                        return _to_consumable_array(prev).concat([
                            currentPage
                        ]);
                    });
                }
                setCheckedRowsIds(newCheckedRowsIds);
            }
            if (isChecked !== -1) {
                var newCheckedRowsIds1 = _to_consumable_array(checkedRowsIds).filter(function(id) {
                    return id !== rowId;
                });
                setCheckedRowsIds(newCheckedRowsIds1);
                // If the page had all rows checked and we uncheck a row,
                // remove the page from the array of pages with all rows checked
                var newPagesWithAllRowsChecked = pagesWithAllRowsChecked.filter(function(item) {
                    return item !== currentPage;
                });
                setPagesWithAllRowsChecked(newPagesWithAllRowsChecked);
                // If we don't have any pages selected and all rows are unchecked it means that we manually unselected
                // all pages so we want to reset the state
                if (newPagesWithAllRowsChecked.length === 0 && newCheckedRowsIds1.length === 0) {
                    setExcludedIds([]);
                    setCheckedRowsIds([]);
                    setCheckedAllPages(false);
                    return;
                }
                // If all pages were checked and we unchecked a row, it means that we want to apply an action for
                // all rows but the unchecked one, so we add it to an excluded rows array which will be sent to the api
                if (checkedAllPages) {
                    setExcludedIds(function(prev) {
                        return _to_consumable_array(prev).concat([
                            rowId
                        ]);
                    });
                }
            }
        }
        function onCheckAllRows(rows, checkAllPages) {
            if (!checkAllPages) {
                // Add/Remove the current page from the array of pages with all rows checked
                if (!pagesWithAllRowsChecked.includes(currentPage)) {
                    setPagesWithAllRowsChecked(function(prev) {
                        return _to_consumable_array(prev).concat([
                            currentPage
                        ]);
                    });
                } else {
                    var newPagesWithAllRowsChecked = pagesWithAllRowsChecked.filter(function(item) {
                        return item !== currentPage;
                    });
                    setPagesWithAllRowsChecked(newPagesWithAllRowsChecked);
                    // If we don't have any pages selected and all rows are unchecked it means that we manually unselected
                    // all pages so we want to reset the state
                    if (newPagesWithAllRowsChecked.length === 0 && checkedRowsIds.length === 0) {
                        setExcludedIds([]);
                        setCheckedRowsIds([]);
                        setCheckedAllPages(false);
                        return;
                    }
                }
            }
            // If we call the function when we check all pages, add all unchecked rows from the current page
            // to the checked rows array
            if (checkAllPages) {
                var uncheckedRowsIds = rows.filter(function(row) {
                    return !checkedRowsIds.includes(row.id);
                }).map(function(item) {
                    return item.id;
                });
                setCheckedRowsIds(function(prev) {
                    return _to_consumable_array(prev).concat(_to_consumable_array(uncheckedRowsIds));
                });
                return;
            }
            // If the current page has all rows checked remove them from the checked rows array
            if (pagesWithAllRowsChecked.includes(currentPage)) {
                var rowsIds = rows.map(function(item) {
                    return item.id;
                });
                var newCheckedRowsIds = checkedRowsIds.filter(function(item) {
                    return !rowsIds.includes(item);
                });
                setCheckedRowsIds(newCheckedRowsIds);
                // If all pages are checked and we have more than one page add the rows to the excluded rows array
                // otherwise change checked all pages to false
                if (checkedAllPages) {
                    setExcludedIds(function(prev) {
                        return _to_consumable_array(prev).concat(_to_consumable_array(rowsIds));
                    });
                }
            }
            // If the current page doesn't have all rows checked get the unchecked rows
            // and add them to the checked rows array
            if (!pagesWithAllRowsChecked.includes(currentPage)) {
                var rowsIds1 = rows.map(function(item) {
                    return item.id;
                });
                var uncheckedRowsIds1 = rows.filter(function(row) {
                    return !checkedRowsIds.includes(row.id);
                }).map(function(item) {
                    return item.id;
                });
                setCheckedRowsIds(function(prev) {
                    return _to_consumable_array(prev).concat(_to_consumable_array(uncheckedRowsIds1));
                });
                // If all pages are checked remove the rows from the excluded rows array
                if (checkedAllPages) {
                    setExcludedIds(function(prev) {
                        return prev.filter(function(item) {
                            return !rowsIds1.includes(item);
                        });
                    });
                }
            }
        }
        /**
         * Effect to remove columns if needed
         */ var screenSize = useSelector(screenBreakpointsSelectors.screenWidth);
        useEffect(function() {
            table.getAllLeafColumns().forEach(function(column) {
                // columnDef.isVisible() must come from the parent, passed within the columns object
                if (column.columnDef.isVisible && column.columnDef.isVisible() !== column.getIsVisible()) {
                    column.toggleVisibility();
                }
            });
        }, [
            screenSize
        ]);
        var searchPlaceholder = translate("common.filters.search.placeholder");
        var columnsWithEnabledSorting = columns.filter(function(item) {
            return item.enableSorting;
        });
        useEffect(function() {
            // If we checked all pages, when we navigate to another page for the first time,
            // we want all the rows from the page to be checked
            if (!checkedAllPages || loaderData.items.find(function(item) {
                return excludedIds.includes(item.id) || checkedRowsIds.includes(item.id);
            })) {
                return;
            }
            loaderData.items && setCheckedRowsIds(function(prev) {
                return _to_consumable_array(prev).concat(_to_consumable_array(loaderData.items.map(function(item) {
                    return item.id;
                })));
            });
        }, [
            currentPage
        ]);
        var processedFilters = generateApiFilters(filters);
        var overShowTableFromBreakpoint = useSelector(screenBreakpointsSelectors.isOver(showTableFromBreakpoint));
        useEffect(function() {
            if (overShowTableFromBreakpoint) {
                return;
            }
            // Reset checked rows when go below showTableFromBreakpoint
            if (checkedRowsIds.length > 0) {
                setCheckedRowsIds([]);
            }
            if (pagesWithAllRowsChecked.length > 0) {
                setPagesWithAllRowsChecked([]);
            }
            if (checkedAllPages) {
                setCheckedAllPages(false);
            }
            if (excludedIds.length > 0) {
                setExcludedIds([]);
            }
        }, [
            overShowTableFromBreakpoint
        ]);
        /**
         * Render
         */ return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PrivatePageHeader, null, title && /*#__PURE__*/ React.createElement(PrivatePageTitle, {
            title: title
        }), /*#__PURE__*/ React.createElement("div", {
            className: twMerge(cc([
                "mb-2 flex w-full items-center gap-x-2 gap-y-2 sm:w-auto sm:gap-x-6",
                {
                    "sm:w-auto": !filtersConfig
                }
            ]))
        }, /*#__PURE__*/ React.createElement("div", {
            className: "w-full flex-grow sm:hidden"
        }, /*#__PURE__*/ React.createElement(Input, {
            name: "search",
            placeholder: searchPlaceholder,
            className: "border-2 py-3 pl-3 pr-8",
            value: searchValue,
            type: "text",
            onChange: onSearch,
            inlineAddonRight: /*#__PURE__*/ React.createElement("div", {
                className: "pr-2"
            }, /*#__PURE__*/ React.createElement(MagnifyingGlassIcon, {
                className: "h-6 w-6"
            }))
        })), filtersConfig && /*#__PURE__*/ React.createElement("button", {
            disabled: navigation.state === "loading" || isFiltersModalLoading,
            onClick: onOpenMobileFiltersModal,
            className: cc([
                "relative group rounded-md border-2 p-3 outline-none hover:border-blue-550 hover:bg-indigo-100 focus:border-blue-550 focus:bg-indigo-100 dark:border-blue-750 dark:bg-blue-775 dark:hover:border-blue-550 dark:hover:bg-blue-760 dark:focus:bg-blue-750 sm:hidden",
                {
                    "has-filters border-blue-550 bg-indigo-100": Object.keys(currentFilters).length > 0
                },
                {
                    "!cursor-not-allowed": navigation.state === "loading" || isFiltersModalLoading
                }
            ])
        }, /*#__PURE__*/ React.createElement(CentralLoader, {
            className: "rounded-lg",
            show: isFiltersModalLoading,
            size: "small"
        }), /*#__PURE__*/ React.createElement(FunnelIcon, {
            className: "h-6 w-6 stroke-gray-400 group-hover:stroke-blue-550 group-focus:stroke-blue-550 group-[.has-filters]:stroke-blue-550"
        })), /*#__PURE__*/ React.createElement("div", {
            className: "text-right sm:hidden"
        }, createButton))), /*#__PURE__*/ React.createElement("div", {
            className: twMerge(cc([
                "mb-5 hidden w-full items-center gap-x-6 gap-y-3 rounded-lg dark:border-gray-600 sm:flex"
            ]))
        }, /*#__PURE__*/ React.createElement("div", {
            className: searchClassName
        }, /*#__PURE__*/ React.createElement(Input, {
            placeholder: searchPlaceholder,
            name: "search",
            className: "border-2 py-3 pl-3 pr-8",
            value: searchValue,
            type: "text",
            disabled: isLoading,
            onChange: onSearch,
            inlineAddonRight: /*#__PURE__*/ React.createElement("div", {
                className: "pr-2 group-[.is-focused]:animate-pulse"
            }, /*#__PURE__*/ React.createElement(MagnifyingGlassIcon, {
                className: "h-6 w-6"
            }))
        })), filtersConfig && /*#__PURE__*/ React.createElement("button", {
            disabled: navigation.state === "loading" || isFiltersModalLoading,
            onClick: onOpenMobileFiltersModal,
            className: cc([
                "relative group hidden rounded-md border-2 p-3 outline-none hover:border-blue-550 hover:bg-indigo-100 focus:border-blue-550 focus:bg-indigo-100 dark:border-blue-750 dark:bg-blue-775 dark:hover:border-blue-550 dark:hover:bg-blue-760 dark:focus:bg-blue-750 sm:block",
                {
                    "has-filters border-blue-550 bg-indigo-100": Object.keys(currentFilters).length > 0
                },
                {
                    "!cursor-not-allowed": navigation.state === "loading" || isFiltersModalLoading
                }
            ])
        }, /*#__PURE__*/ React.createElement(CentralLoader, {
            className: "rounded-lg",
            show: isFiltersModalLoading,
            size: "small"
        }), /*#__PURE__*/ React.createElement(FunnelIcon, {
            className: "h-6 w-6 stroke-gray-400 group-hover:stroke-blue-550 group-focus:stroke-blue-550 group-[.has-filters]:stroke-blue-550"
        })), /*#__PURE__*/ React.createElement("div", {
            className: twMerge(cc([
                "ml-auto",
                {
                    "flex items-center gap-x-6": listActions
                }
            ]))
        }, checkedRowsIds.length > 0 && /*#__PURE__*/ React.createElement("div", null, listActions({
            checkedRowsIds: checkedRowsIds,
            excludedIds: excludedIds,
            checkedAllPages: checkedAllPages,
            filters: processedFilters,
            search: searchValue,
            count: checkedAllPages ? excludedIds.length > 0 ? loaderData.count - excludedIds.length : loaderData.count : checkedRowsIds.length
        })), createButton)), columnsWithEnabledSorting.length > 0 && /*#__PURE__*/ React.createElement("div", {
            className: twMerge(cc([
                "mb-2 flex flex-col sm:flex-row gap-y-1.5 w-full gap-x-3 rounded-lg bg-gray-150 px-2 py-4 shadow dark:bg-blue-800 ".concat(showTableFromBreakpoint, ":hidden")
            ]))
        }, /*#__PURE__*/ React.createElement("div", {
            className: "flex-[7 1 30%] min-w-0 flex-grow"
        }, /*#__PURE__*/ React.createElement(ReactSelect, {
            label: translate("common.list.sortBy.label"),
            name: "sortBy",
            value: currentSortBy,
            onChange: function(e) {
                return mobileChangeSorting({
                    column: e.target.value
                });
            },
            items: columns.filter(function(item) {
                return item.enableSorting;
            }),
            itemToLabel: function(item) {
                return item.header;
            },
            itemToValue: function(item) {
                return item.accessorKey;
            }
        })), /*#__PURE__*/ React.createElement("div", {
            className: "flex-[4 1 30%] min-w-fit flex-grow"
        }, /*#__PURE__*/ React.createElement(ReactSelect, {
            label: translate("common.list.sortDirection.label"),
            name: "sortDir",
            value: currentSortDir,
            onChange: function(e) {
                return mobileChangeSorting({
                    direction: e.target.value
                });
            },
            items: [
                {
                    label: translate("common.list.sortDirection.ascending"),
                    value: SORT_ASC
                },
                {
                    label: translate("common.list.sortDirection.descending"),
                    value: SORT_DESC
                }
            ]
        }))), (checkedRowsIds.length > 0 || excludedIds.length > 0) && /*#__PURE__*/ React.createElement("div", {
            className: "mb-3 hidden items-center justify-start gap-3 xl:flex"
        }, /*#__PURE__*/ React.createElement("div", {
            className: "text-black dark:text-gray-50"
        }, checkedAllPages ? excludedIds.length > 0 ? selectedItemsLabel(loaderData.count - excludedIds.length) : selectedItemsLabel(loaderData.count) : selectedItemsLabel(checkedRowsIds.length)), !checkedAllPages && checkedRowsIds.length !== loaderData.count && /*#__PURE__*/ React.createElement("button", {
            className: "text-blue-500 hover:text-blue-550 transition hover:underline focus:underline focus:text-blue-550 focus:outline-none",
            onClick: function() {
                onCheckAllRows(loaderData.items, true);
                setPagesWithAllRowsChecked(Array.from({
                    length: totalPages
                }, function(_, i) {
                    return i + 1;
                }));
                setCheckedAllPages(true);
            }
        }, /*#__PURE__*/ React.createElement(Trans, null, "common.list.check-all-pages")), (checkedAllPages || checkedRowsIds.length === loaderData.count) && /*#__PURE__*/ React.createElement("button", {
            className: "text-red-450 hover:text-red-500 transition hover:underline focus:underline focus:text-red-500 focus:outline-none",
            onClick: function() {
                setPagesWithAllRowsChecked([]);
                setCheckedRowsIds([]);
                setExcludedIds([]);
                setCheckedAllPages(false);
            }
        }, /*#__PURE__*/ React.createElement(Trans, null, "common.list.uncheck-all-pages"))), /*#__PURE__*/ React.createElement("div", {
            className: twMerge(cc([
                "block relative overflow-hidden rounded-lg",
                {
                    "sm:table sm:shadow sm:bg-white sm:dark:bg-blue-800": showTableFromBreakpoint === "sm",
                    "xl:table xl:shadow xl:bg-white xl:dark:bg-blue-800": showTableFromBreakpoint === "xl"
                }
            ]))
        }, /*#__PURE__*/ React.createElement(CentralLoader, {
            className: "rounded-lg",
            show: isReloadingTable
        }), loaderData.items.length > 0 && /*#__PURE__*/ React.createElement("table", {
            className: twMerge(cc([
                "hidden w-full bg-white text-black dark:bg-blue-800 dark:text-gray-200",
                {
                    "sm:table": showTableFromBreakpoint === "sm",
                    "xl:table": showTableFromBreakpoint === "xl"
                }
            ]))
        }, /*#__PURE__*/ React.createElement("thead", {
            className: "bg-gray-150 dark:bg-blue-800"
        }, table.getHeaderGroups().map(function(headerGroup) {
            return /*#__PURE__*/ React.createElement("tr", {
                key: headerGroup.id
            }, headerGroup.headers.map(function(header, index) {
                return /*#__PURE__*/ React.createElement(React.Fragment, {
                    key: header.id
                }, index === 0 && listActions && /*#__PURE__*/ React.createElement("th", {
                    className: twMerge(cc([
                        "hidden w-5 p-0 px-4",
                        {
                            "sm:table-cell": showTableFromBreakpoint === "sm",
                            "xl:table-cell": showTableFromBreakpoint === "xl"
                        }
                    ]))
                }, /*#__PURE__*/ React.createElement(Checkbox, {
                    onChange: function() {
                        return onCheckAllRows(loaderData.items);
                    },
                    name: headerGroup.id,
                    value: pagesWithAllRowsChecked.includes(currentPage)
                })), /*#__PURE__*/ React.createElement("th", {
                    className: twMerge(cc([
                        "hidden p-0",
                        {
                            "sm:table-cell": showTableFromBreakpoint === "sm",
                            "xl:table-cell": showTableFromBreakpoint === "xl"
                        }
                    ]))
                }, header.column.columnDef.enableSorting && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("button", {
                    onClick: function() {
                        return changeSorting(header.id);
                    },
                    className: twMerge(cc([
                        "flex w-full items-center justify-center gap-x-2 p-3 pl-8 outline-none hover:cursor-pointer hover:bg-gray-250 focus:bg-gray-250 dark:hover:bg-blue-750 dark:focus:bg-blue-750",
                        {
                            "justify-start pl-5 text-left": index === 0
                        },
                        header.column.columnDef.thClassName,
                        {
                            "xs:hidden hidden sm:hidden md:hidden xl:hidden 2xl:hidden 3xl:hidden": header.column.columnDef.isHidden
                        }
                    ]))
                }, flexRender(header.column.columnDef.header, header.getContext()), /*#__PURE__*/ React.createElement("div", {
                    className: "p-1"
                }, currentSortBy === header.id && currentSortDir === SORT_DESC && /*#__PURE__*/ React.createElement(ChevronDownIcon, {
                    className: "h-5 w-4"
                }), currentSortBy === header.id && currentSortDir === SORT_ASC && /*#__PURE__*/ React.createElement(ChevronUpIcon, {
                    className: "h-5 w-4"
                }), currentSortBy !== header.id && /*#__PURE__*/ React.createElement(ChevronUpDownIcon, {
                    className: "h-5 w-5"
                })))), !header.column.columnDef.enableSorting && /*#__PURE__*/ React.createElement("div", {
                    className: twMerge(cc([
                        "flex w-full items-center justify-center gap-x-2 p-3",
                        {
                            "justify-start pl-5": index === 0
                        },
                        header.column.columnDef.thClassName,
                        {
                            "xs:hidden hidden sm:hidden md:hidden xl:hidden 2xl:hidden 3xl:hidden": header.column.columnDef.isHidden
                        }
                    ]))
                }, flexRender(header.column.columnDef.header, header.getContext()))));
            }));
        })), /*#__PURE__*/ React.createElement("tbody", null, table.getRowModel().rows.map(function(row) {
            return /*#__PURE__*/ React.createElement("tr", {
                key: row.original[primaryKey],
                onClick: function() {
                    return handleRowClick ? !listActions || listActions && checkedRowsIds.length === 0 ? handleRowClick(row) : onCheckOneRow(row.original.id) : null;
                },
                className: twMerge(cc([
                    "group relative grid grid-cols-12 border-b px-2 py-4 text-black last:border-none even:bg-gray-100 dark:border-gray-600 dark:bg-blue-760 dark:text-gray-200 dark:even:bg-blue-770",
                    {
                        "bg-blue-100 even:bg-blue-100 dark:bg-blue-775 dark:even:bg-blue-775": checkedRowsIds.includes(row.original.id),
                        "sm:px-5": showTableFromBreakpoint !== "sm",
                        "sm:table-row sm:px-0 sm:py-0": showTableFromBreakpoint === "sm",
                        "xl:table-row xl:px-0 xl:py-0": showTableFromBreakpoint === "xl"
                    },
                    {
                        "cursor-pointer": handleRowClick
                    }
                ]))
            }, row.getVisibleCells().map(function(cell, index) {
                return /*#__PURE__*/ React.createElement(React.Fragment, {
                    key: cell.id
                }, index === 0 && listActions && /*#__PURE__*/ React.createElement("td", {
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    className: twMerge(cc([
                        "hidden w-5 p-0 px-4 transition duration-75 group-hover:bg-blue-100 dark:group-hover:bg-blue-775",
                        {
                            "sm:table-cell": showTableFromBreakpoint === "sm",
                            "xl:table-cell": showTableFromBreakpoint === "xl"
                        }
                    ]))
                }, /*#__PURE__*/ React.createElement(Checkbox, {
                    className: twMerge(cc([
                        "",
                        {
                            "group-hover:ring-blue-500  dark:group-hover:ring-blue-300 group-hover:ring-2": checkedRowsIds.length
                        }
                    ])),
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    onChange: function() {
                        return onCheckOneRow(row.original.id);
                    },
                    name: row.original.id.toString(),
                    value: checkedRowsIds.includes(row.original.id)
                })), /*#__PURE__*/ React.createElement("td", {
                    onClick: function(e) {
                        if (cell.column.id === "ACTIONS") {
                            if (checkedRowsIds.length > 0) {
                                onCheckOneRow(row.original.id);
                            }
                            e.stopPropagation();
                        }
                    },
                    className: twMerge(cc([
                        "col-span-12 grid py-0 pl-2 pr-10 transition duration-75 group-hover:bg-blue-100 dark:group-hover:bg-blue-775",
                        {
                            "sm:table-cell sm:pl-0 sm:pr-0": showTableFromBreakpoint === "sm",
                            "xl:table-cell xl:pl-0 xl:pr-0": showTableFromBreakpoint === "xl"
                        }
                    ]))
                }, /*#__PURE__*/ React.createElement("div", {
                    onClick: function(e) {
                        if (cell.column.id === "ACTIONS") //To prevent <tr> onclick to be called when we click on dropdown from actions
                        e.stopPropagation();
                    },
                    "data-cell": cell.column.columnDef.header || null,
                    className: twMerge(cc([
                        "grid grid-cols-[20ch,auto] gap-x-3 py-3 text-sm md:grid-cols-[1fr,2fr]  2xl:text-base",
                        {
                            "sm:grid-cols-[1fr,2fr]": showTableFromBreakpoint !== "sm",
                            "sm:block ": showTableFromBreakpoint === "sm",
                            "xl:block ": showTableFromBreakpoint === "xl",
                            //If the row doesn't have a header, we won't render "before", but we still want
                            //to render the cell content (ex: actions dropdown) and we set py to 0 so that
                            //it does not take up space. If we want to hide the cell content, we do it from
                            //integrator in tdClassName property.
                            "before:overflow-hidden before:p-1 before:font-semibold before:content-[attr(data-cell)] sm:before:p-0 sm:before:content-none": cell.column.columnDef.header && showTableFromBreakpoint === "sm",
                            "before:overflow-hidden before:p-1 before:font-semibold before:content-[attr(data-cell)] xl:before:p-0 xl:before:content-none": cell.column.columnDef.header && showTableFromBreakpoint === "xl",
                            "py-0": !cell.column.columnDef.header,
                            "items-center sm:mr-1.5 sm:justify-start sm:pl-5": index === 0 && showTableFromBreakpoint === "sm",
                            "items-center xl:mr-1.5 xl:justify-start xl:pl-5": index === 0 && showTableFromBreakpoint === "xl",
                            "items-center sm:flex sm:justify-end": cell.column.id === "ACTIONS" && showTableFromBreakpoint === "sm",
                            "items-center xl:flex xl:justify-end": cell.column.id === "ACTIONS" && showTableFromBreakpoint === "xl",
                            "right-[14px] top-0 cursor-default sm:right-[18px] md:right-[20px]": cell.column.id === "ACTIONS",
                            "sm:relative sm:right-0 sm:pl-[10px] sm:pr-[20px]": cell.column.id === "ACTIONS" && showTableFromBreakpoint === "sm",
                            "sm:xl-[10px] xl:relative xl:right-0 xl:pl-[10px] xl:pr-[20px]": cell.column.id === "ACTIONS" && showTableFromBreakpoint === "xl",
                            "pointer-events-none invisible": cell.column.id === "ACTIONS" && (checkedRowsIds.length > 0 || excludedIds.length > 0)
                        },
                        cell.column.columnDef.tdClassName,
                        {
                            "xs:hidden hidden sm:hidden md:hidden xl:hidden 2xl:hidden 3xl:hidden": cell.column.columnDef.isHidden
                        },
                        {
                            "pointer-events-none": checkedRowsIds.length
                        }
                    ]))
                }, flexRender(cell.column.columnDef.cell, cell.getContext()))));
            }));
        }))), /*#__PURE__*/ React.createElement("div", {
            className: cc([
                "contents h-fit flex-auto rounded-b-lg bg-white shadow dark:bg-blue-775",
                {
                    "sm:hidden": showTableFromBreakpoint === "sm"
                },
                {
                    "xl:hidden": showTableFromBreakpoint === "xl"
                }
            ])
        }, /*#__PURE__*/ React.createElement(React.Fragment, null, tableData.map(function(entity, rowIndex) {
            var rows = table.getRowModel().rows[rowIndex].getVisibleCells();
            return /*#__PURE__*/ React.createElement("div", {
                key: rows[0].row.id,
                className: "relative"
            }, table.getHeaderGroups().map(function(headerGroup) {
                var actionsHeader = headerGroup.headers.find(function(h) {
                    return h.id === "ACTIONS";
                });
                var actionsIndex = headerGroup.headers.findIndex(function(h) {
                    return h.id === "ACTIONS";
                });
                return actionsHeader ? /*#__PURE__*/ React.createElement(React.Fragment, {
                    key: "".concat(headerGroup.id, "_ACTIONS")
                }, rows[actionsIndex] && flexRender(rows[actionsIndex].column.columnDef.cell, rows[actionsIndex].getContext())) : null;
            }), /*#__PURE__*/ React.createElement("div", {
                onClick: function() {
                    handleRowClick && handleRowClick(rows[0].row);
                },
                className: twMerge(cc([
                    "mb-3 rounded-md grid grid-cols-10 text-black shadow-md dark:bg-blue-800 dark:text-gray-200 dark:border-gray-600 sm:mb-4 md:p-0 not:last:[&>*:nth-child(2n)]:border-b sm:[&>*:nth-child(n)]:border-b",
                    {
                        "cursor-pointer group": handleRowClick
                    }
                ]))
            }, table.getHeaderGroups().map(function(headerGroup) {
                var headersWithoutActions = headerGroup.headers.filter(function(header) {
                    return header.id !== "ACTIONS";
                });
                return /*#__PURE__*/ React.createElement(React.Fragment, {
                    key: headerGroup.id
                }, headersWithoutActions.map(function(header, headerIndex) {
                    return /*#__PURE__*/ React.createElement(React.Fragment, {
                        key: "".concat(header.id, "_fragment")
                    }, /*#__PURE__*/ React.createElement("div", {
                        className: twMerge(cc([
                            "col-span-5 flex items-center border-b dark:border-gray-600 bg-blue-50 pb-5 pe-0 ps-5 pt-5 dark:bg-blue-775 sm:col-span-4 md:col-span-3 [&:nth-last-child(2)]:border-b-0 sm:[&:nth-last-child(2)]:odd:border-b-0",
                            // {
                            //     "col-span-10 odd:border-b-0":
                            //         headersThatWeMightWantToSplitInTwoRowsOnMobile.includes(header.id)
                            // },
                            {
                                "rounded-tl-md": headerIndex === 0
                            },
                            {
                                "rounded-tl-none": headerIndex !== 0
                            },
                            {
                                "rounded-tl-md": headerIndex === 0 && rowIndex === 0
                            },
                            {
                                "rounded-bl-md": headerIndex === headersWithoutActions.length - 1
                            },
                            {
                                "rounded-bl-none": headerIndex !== headersWithoutActions.length - 1
                            },
                            {
                                "rounded-bl-md": rowIndex === rows.length - 1 && headerIndex === headersWithoutActions.length - 1
                            },
                            // {
                            //     "rounded-br-none sm:rounded-bl-md rounded-bl-none":
                            //         headersThatWeMightWantToSplitInTwoRowsOnMobile.includes(header.id) &&
                            //         headerIndex !== 0,
                            // },
                            // {
                            //     "rounded-tr-md sm:rounded-tr-none":
                            //         header.id === "seriesAndNumber" &&
                            //         headerIndex !==
                            //             headersWithoutActions.length - 1,
                            // },
                            {
                                "dark:group-hover:bg-blue-760 group-hover:bg-blue-100 dark:group-hover:border-gray-500 group-hover:border-gray-300": handleRowClick
                            }
                        ]))
                    }, /*#__PURE__*/ React.createElement("div", {
                        className: "me-4"
                    }, flexRender(header.column.columnDef.header, header.getContext()))), /*#__PURE__*/ React.createElement("div", {
                        className: twMerge(cc([
                            "col-span-5 border-b dark:border-gray-600 bg-white pb-5 ps-0 pt-5 last:border-b-0 dark:bg-blue-760 sm:col-span-6 sm:even:border-b-0 sm:last:even:border-b-0 md:col-span-7",
                            {
                                "pe-0": headerIndex === 0
                            },
                            // { "pe-5": headerIndex > 0 },
                            // {
                            //     "col-span-10":
                            //         headersThatWeMightWantToSplitInTwoRowsOnMobile.includes(header.id)
                            // },
                            // {
                            //     flex: !headersThatWeMightWantToSplitInTwoRowsOnMobile.includes(header.id),
                            // },
                            // { flex: true },
                            {
                                "rounded-tr-md": headerIndex === 0 && rowIndex === 0
                            },
                            {
                                "rounded-tr-md": headerIndex === 0
                            },
                            {
                                "rounded-tr-none": headerIndex !== 0
                            },
                            {
                                "rounded-br-md": headerIndex === headersWithoutActions.length - 1
                            },
                            {
                                "rounded-bl-none": headerIndex !== headersWithoutActions.length - 1
                            },
                            {
                                "rounded-bl-md": rowIndex === rows.length - 1 && headerIndex === headersWithoutActions.length - 1
                            },
                            // {
                            //     "rounded-bl-none rounded-tr-none sm:rounded-tr-md":
                            //         headersThatWeMightWantToSplitInTwoRowsOnMobile.includes(header.id) &&
                            //         headerIndex === 0,
                            // },
                            // {
                            //     "rounded-bl-md sm:rounded-bl-none":
                            //         headersThatWeMightWantToSplitInTwoRowsOnMobile.includes(header.id) &&
                            //         headerIndex !== 0,
                            // },
                            {
                                "group-hover:bg-blue-50 dark:group-hover:bg-blue-750 dark:group-hover:border-gray-500 group-hover:border-gray-300": handleRowClick
                            }
                        ]))
                    }, /*#__PURE__*/ React.createElement("div", {
                        className: "items-center space-between me-4 ms-4 flex flex-row"
                    }, /*#__PURE__*/ React.createElement(React.Fragment, null, rows && rows[headerIndex] && flexRender(rows[headerIndex].column.columnDef.cell, rows[headerIndex].getContext())))));
                }));
            })));
        }))), loaderData.items.length === 0 && Object.keys(currentFilters).length === 0 && !currentSearch && emptyState, loaderData.items.length === 0 && (Object.keys(currentFilters).length > 0 || currentSearch) && filtersEmptyState({
            onResetFilters: function() {
                return onResetFilters();
            }
        })), totalPages > 1 && /*#__PURE__*/ React.createElement("nav", {
            className: "sticky bottom-0 mt-auto flex justify-center bg-white py-2 dark:bg-blue-800 sm:relative sm:mt-0 sm:bg-transparent dark:sm:bg-transparent"
        }, /*#__PURE__*/ React.createElement("button", {
            disabled: !hasPrevious,
            className: twMerge(cc([
                "inline-flex items-center gap-2 p-2 text-gray-500 transition dark:text-gray-200",
                {
                    "cursor-not-allowed text-gray-300 dark:text-gray-700": !hasPrevious
                },
                {
                    "hover:bg-gray-200 hover:text-blue-550 dark:hover:bg-blue-760 dark:hover:text-blue-550": hasPrevious
                }
            ])),
            onClick: onPreviousPage
        }, /*#__PURE__*/ React.createElement(ChevronLeftIcon, {
            className: "h-5 w-5"
        })), links.map(function(link, index) {
            return /*#__PURE__*/ React.createElement("button", {
                key: index,
                className: twMerge(cc([
                    "inline-flex items-center px-3 py-2 text-sm font-medium text-black transition hover:bg-gray-200 hover:text-blue-550 dark:text-gray-200 dark:hover:bg-blue-760 dark:hover:text-blue-550",
                    {
                        "bg-indigo-100 text-blue-550 hover:bg-blue-200 dark:bg-blue-775": link.active
                    }
                ])),
                onClick: function() {
                    return syncUrl({
                        page: link.label
                    });
                },
                "aria-current": "page"
            }, link.label);
        }), /*#__PURE__*/ React.createElement("button", {
            disabled: !hasNext,
            className: twMerge(cc([
                "inline-flex items-center gap-2 rounded-md p-2 text-gray-500 transition dark:text-gray-200",
                {
                    "cursor-not-allowed text-gray-300 dark:text-gray-700": !hasNext
                },
                {
                    "hover:bg-gray-200 hover:text-blue-550 dark:hover:bg-blue-760 dark:hover:text-blue-550": hasNext
                }
            ])),
            onClick: onNextPage
        }, /*#__PURE__*/ React.createElement(ChevronRightIcon, {
            className: "h-5 w-5"
        }))), !isOutletRenderedByParent && /*#__PURE__*/ React.createElement(Outlet, {
            context: outletCtx
        }));
    }
    return {
        /**
         * The Data Loader for the page
         */ dataLoader: dataLoader,
        DataList: DataList
    };
}
